/**
 * Unknown sign-in error
 */
export const UNKNOWN_SIGN_IN_ERROR = "UNKNOWN_SIGN_IN_ERROR";

/**
 * Clock skew sign-in error
 */
export const CLOCK_SKEW_SIGN_IN_ERROR = "CLOCK_SKEW_SIGN_IN_ERROR";

/**
 * User login with invalid url
 * e.g bookmarked SOUP login page where skipping browser crypto key creation
 * where callback url is not verifiable
 */
export const INVALID_SIGN_IN_URL = "INVALID_SIGN_IN_URL_ERROR";

/**
 * Notify upstream component user session is no longer valid
 */
export const SESSION_TIMEOUT = "SESSION_TIMEOUT";
